<div class="active-reservation-notice" *ngIf="notice as activeNotice">
  <button
    *ngIf="collapsed; else expandedNotice"
    type="button"
    class="active-reservation-notice__pill"
    (click)="expand()"
    [disabled]="isToggling"
    [attr.aria-label]="'ACTIVE_RESERVATION_NOTICE.SHOW_ARIA' | translate"
  >
    <span class="active-reservation-notice__dot" aria-hidden="true"></span>
    <span class="active-reservation-notice__pill-title">
      {{ 'ACTIVE_RESERVATION_NOTICE.TITLE' | translate }}
    </span>
    <span
      class="active-reservation-notice__pill-expiry"
      *ngIf="expiresInLabel"
    >
      {{ 'ACTIVE_RESERVATION_NOTICE.EXPIRES_IN' | translate }}
      {{ expiresInLabel }}
    </span>
    <mat-icon
      class="active-reservation-notice__pill-icon"
      svgIcon="visibility"
      aria-hidden="true"
    ></mat-icon>
  </button>

  <ng-template #expandedNotice>
    <div class="active-reservation-notice__inner">
      <div class="active-reservation-notice__content">
        <div class="active-reservation-notice__headline">
          <div class="active-reservation-notice__title-group">
            <span class="active-reservation-notice__icon-wrap" aria-hidden="true">
              <mat-icon
                class="active-reservation-notice__icon"
                svgIcon="payments"
              ></mat-icon>
            </span>
            <p class="active-reservation-notice__title">
              {{ 'ACTIVE_RESERVATION_NOTICE.TITLE' | translate }}
            </p>
            <span class="active-reservation-notice__dot" aria-hidden="true"></span>
          </div>

          <div class="active-reservation-notice__actions active-reservation-notice__actions--mobile">
            <button
              type="button"
              class="active-reservation-notice__qr-btn"
              (click)="viewQr()"
            >
              {{ 'ACTIVE_RESERVATION_NOTICE.VIEW_QR' | translate }}
            </button>
            <button
              type="button"
              class="active-reservation-notice__hide-btn"
              (click)="collapse()"
              [disabled]="isToggling"
              [attr.aria-label]="
                'ACTIVE_RESERVATION_NOTICE.HIDE_ARIA' | translate
              "
            >
              <mat-icon svgIcon="visibility_off"></mat-icon>
            </button>
          </div>
        </div>

        <div class="active-reservation-notice__meta">
          <p class="active-reservation-notice__amount">
            <span class="active-reservation-notice__amount-value">
              ${{ activeNotice.foreignAmount | number : '1.0-2' }}
              {{ activeNotice.currencyCode }}
            </span>
            <span class="active-reservation-notice__amount-label">
              {{ 'ACTIVE_RESERVATION_NOTICE.HELD_AT' | translate }}
            </span>
            <span class="active-reservation-notice__amount-value">
              ${{ activeNotice.exchangeRate | number : '1.2-2' }}
            </span>
          </p>

          <div
            class="active-reservation-notice__chip"
            *ngIf="activeNotice.branchName"
          >
            <mat-icon
              class="active-reservation-notice__chip-icon"
              svgIcon="fmd_good"
            ></mat-icon>
            <span>{{ activeNotice.branchName }}</span>
          </div>

          <div
            class="active-reservation-notice__chip active-reservation-notice__chip--expiry"
            *ngIf="expiresInLabel"
          >
            <mat-icon
              class="active-reservation-notice__chip-icon"
              svgIcon="schedule"
            ></mat-icon>
            <span>
              {{ 'ACTIVE_RESERVATION_NOTICE.EXPIRES_IN' | translate }}
              {{ expiresInLabel }}
            </span>
          </div>
        </div>
      </div>

      <div class="active-reservation-notice__actions active-reservation-notice__actions--desktop">
        <button
          type="button"
          class="active-reservation-notice__qr-btn"
          (click)="viewQr()"
        >
          {{ 'ACTIVE_RESERVATION_NOTICE.VIEW_QR' | translate }}
        </button>
        <button
          type="button"
          class="active-reservation-notice__hide-btn"
          (click)="collapse()"
          [disabled]="isToggling"
          [attr.aria-label]="'ACTIVE_RESERVATION_NOTICE.HIDE_ARIA' | translate"
        >
          <mat-icon svgIcon="visibility_off"></mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</div>
